<template>
 <div class="eventlistcontainer">
    <h2 style="text-align:center;">All Events</h2>
    <b-card-group deck class="eventlist_deck">
      <div v-for="event in events"
        class="card eventlist_card"
        >
        <div style="width:100%;text-align:center;">
          <img style="max-width:100%;max-height:10rem;height:auto;vertical-align:middle;" :src="event.banner">
          </img>
        </div>
        <div class="card-body">
          <h4 class="card-title">
            {{ event.name }}
          </h4>
          <b-card-text>
             {{ utils.abridgeDescr(event) }}
          </b-card-text>
          <b-button :to="{ name:'event', params: { ev: event, id: event.id }}" variant="primary">
            View Event
          </b-button>
        </div>
      </div> 
    </b-card-group><br>
    <b-collapse v-model="signin_redirect">
        <h4>You're not signed in</h4>
        <b-button variant="success" :to="{name: 'login'}">Sign in</b-button>
    </b-collapse>
  </div>
</template>

<script>

import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";

export default {
  name: "eventlist",
  data() {
    return {
      utils: utils,
      authenticated: false,
      events: [],
      signin_redirect: false,
    }
  },
  components: {
  },
  created() {
  },
  methods: {
	deleteAll: function() {
		this.events.forEach(function(ev) {
			window.wss_send(vx, "adm_event_del", {
                            e:{
          			id: ev.id
			    }
                        });
		});
		this.$router.push({path: '/eventmanager'});
	},        
  },
  computed: {
  },
  beforeDestroy() {
     window.wss_clr_routes(window.vx,"eventlist");
  },
  mounted() {
    $("body").removeClass("setbackground");
    let vue = this;
    window.wss_open(vx, {
      acc: vue.$router.currentRoute.params.acc,
      uid: (vx.user)? vx.user.id: "not set",
      routes_id: "eventlist",
      routes: {
        auth_me: function(){
           // Called once authenticated with lambda APIs
        },
	opened: function() {
           // The event request
      	   window.wss_send(vx, "adm_event_list", {rtag: "eventlist",
           });
	},
        // Various handlers here depending on need
        adm_event_list: function(msg) {
	    if (msg.rtag != "eventlist") return;
            msg.data.events.forEach(function(ev) {
               utils.remote_to_local(ev);
            });
	    vue.events = msg.data.events;
	},
	adm_event_del: function(msg) {
	    if (msg.data.error) {
	       console.log(msg.data.error);
	    } else {
	       console.log("Event deleted");
	    }
	},
      }
    });
  },
};
</script>

<style lang="scss" scoped>

.eventlist_deck {
  justify-content: center;
  margin-right:0;
  margin-left:0;
}

.eventlistcontainer {
   background-color: #c0d0d0;
   max-width:90%;
   margin: 0 5%;
}

@media screen and (max-width:600px) and (orientation:portrait) {
.eventlistcontainer {
  max-width:100%;
  margin: 0;
}
}

.eventlist_card {
  min-width: 20rem;
  max-width: 30rem;
  min-height: 20rem;
  margin-top: 10px;
  margin-bottom: 10px;
}

</style>
